export default __webpack_public_path__ + "static/kia serato-aa82de94b126eff7f7a12a04840fe69d.png";